import examFindingReducer from './examFindingReducer';
import previousExamReducer from './previousExamReducer';

const examReducers ={
  previousExam: previousExamReducer,
  examFinding: examFindingReducer,
};

export default examReducers;